<table mat-table
       [dataSource]="dataSource"
       matSort
       (matSortChange)="onSortChange($event)">
  <ng-container matColumnDef="image">
    <th mat-header-cell
        *matHeaderCellDef>
    </th>
    <td mat-cell
        *matCellDef="let element"
        (click)="onSelect(element)">
      <app-avatar [imageSrc]="element[imageColumn]"></app-avatar>
    </td>
    <td mat-footer-cell
        *matFooterCellDef>
    </td>
  </ng-container>

  <ng-container matColumnDef="index"
                [sticky]="true">
    <th mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [disabled]="!isDataArray"
        [ngClass]="{'no-label': true}">
    </th>
    <td mat-cell
        *matCellDef="let element; let i = index">
      {{ isDataArray ? element.index : elementIndex(i) }}
    </td>
    <td mat-footer-cell
        *matFooterCellDef>
    </td>
  </ng-container>

  <ng-container *ngFor="let column of columns; let i = index"
                [matColumnDef]="column.value">
    <th mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [disabled]="column.sortDisabled"
        [ngClass]="{'no-label': !column.label, 'with-template': column.template}"
        [hidden]="column.hideFn && column.hideFn()">
      {{ translateHeaderName(column.label) }}
    </th>
    <ng-container *ngIf="hasTooltip">
      <td mat-cell
          *matCellDef="let element; let i = index"
          (click)="onSelect(element)"
          [matTooltip]="cellValue(element, column) | translate"
          [ngClass]="{'with-template': column.template, 'highlighted': highlightFn && highlightFn(element)}"
          [hidden]="column.hideFn && column.hideFn()"
          appShowIfTruncated>
        <ng-container *ngIf="column.template; else simpleColumn">
          <ng-container *ngTemplateOutlet="column.template; context: {$implicit: element}"></ng-container>
        </ng-container>
        <ng-template #simpleColumn>{{ cellValue(element, column) | translate }}</ng-template>
      </td>
    </ng-container>
    <ng-container *ngIf="!hasTooltip">
      <td mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="{'with-template': column.template, 'highlighted': highlightFn && highlightFn(element)}"
          [hidden]="column.hideFn && column.hideFn()"
          (click)="onSelect(element)"
          appShowIfTruncated>
        <ng-container *ngIf="column.template; else simpleColumn">
          <ng-container *ngTemplateOutlet="column.template; context: {$implicit: element}"></ng-container>
        </ng-container>
        <ng-template #simpleColumn>
          <div [innerHTML]="cellValue(element, column) | translate"></div>
        </ng-template>
      </td>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let actionColumn of actionColumns"
                [matColumnDef]="actionColumn.action">
    <th class="action-header-cell"
        mat-header-cell
        *matHeaderCellDef></th>
    <td class="action-cell"
        mat-cell
        *matCellDef="let element">
      <button mat-icon-button
              class="action-button"
              [disabled]="actionColumn.disabledFn && actionColumn.disabledFn(element)"
              (click)="onAction(element, actionColumn.action)">
        <mat-icon *ngIf="actionColumn.svgIcon; else simpleIcon"
                  [svgIcon]="shouldHighlightRow(element) ? actionColumn.highlightSvgIcon : actionColumn.svgIcon">
        </mat-icon>
        <ng-template #simpleIcon>
          <mat-icon>{{actionColumn.icon}}</mat-icon>
        </ng-template>
      </button>
    </td>
    <td mat-footer-cell
        *matFooterCellDef>
    </td>
  </ng-container>

  <!-- Footer rows defined together with specific columns. -->
  <ng-container *ngFor="let footerRow of footerRows">
    <ng-container *ngFor="let column of footerRow.columns">
      <ng-container [matColumnDef]="column.value">
        <td mat-footer-cell
            *matFooterCellDef
            [hidden]="column.hideFn && column.hideFn()" [style]="column.style">
          {{ footerCellValue(column) | translate | uppercase }}
        </td>
      </ng-container>
    </ng-container>
  </ng-container>

  <tr mat-header-row
      *matHeaderRowDef="matDefinedColumns, sticky: true"></tr>
  <tr mat-row
      *matRowDef="let row; columns: matDefinedColumns;"
      [ngClass]="{'highlighted': shouldHighlightRow(row)}"
      [ngStyle]="{'background-color': shouldHighlightRow(row) ? highlightColor : false}">
  </tr>
  <ng-container *ngFor="let footerRow of footerRows">
    <tr mat-footer-row
        *matFooterRowDef="matDefinedFooterColumns(footerRow), sticky: true"
        [hidden]="dataLength === 0">
    </tr>
  </ng-container>

  <!-- Row shown when there are no items. -->
  <tr class="mat-row no-data-row"
      *matNoDataRow
      [hidden]="nextItemsLoading">
    <td class="mat-cell"
        [colSpan]="matDefinedColumns.length">
      <div class="no-items">{{'general.texts.noData' | translate}}</div>
    </td>
  </tr>

  <!-- Row shown when there are more items to load. -->
  <ng-container matColumnDef="dataLoading">
    <td mat-footer-cell
        *matFooterCellDef
        [colSpan]="matDefinedColumns.length">
      <div class="items-loading">
        <app-loading-spinner diameter="32"></app-loading-spinner>
      </div>
    </td>
  </ng-container>

  <tr mat-footer-row
      class="mat-row loading-data-row"
      *matFooterRowDef="['dataLoading']"
      [hidden]="!nextItemsLoading">
  </tr>
</table>

<mat-paginator *ngIf="hasPagination"
               [pageIndex]="config?.pager?.page"
               [pageSize]="config?.pager?.pageSize"
               [length]="dataLength"
               [pageSizeOptions]="pageSizeOptions"
               [showFirstLastButtons]="true"
               [disabled]="nextItemsLoading"
               (page)="onPageChange($event)">
</mat-paginator>
